import React, { useEffect, useState } from 'react'
import Form from './Form'
import Info from '../Common/Info'
import { issueBadge, getBadges } from '../../store/actions/badge'
import { validateEmail } from '../../utils/parseData'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'

function IssueBadge({ badge, issueBadge, getBadges }) {
  const {
    state: { badgeName },
  } = useLocation()
  const { badges, issueBadgeSuccess, issueBadgeError } = badge
  const [formObj, setFormObj] = useState({
    state: 'idle',
    userEmail: { status: '', value: '' },
    selectedBadge: badgeName !== '' ? badgeName : 'Select the badge',
  })

  useEffect(() => {
    getBadges(formObj, setFormObj)
  }, [getBadges])

  const onChangeHandler = (e) => {
    const fieldValue = e.target.value
    const fieldName = e.target.name
    setFormObj((data) => ({
      ...data,
      [fieldName]: fieldValue,
    }))
  }

  const emailHandler = (e) => {
    const value = e.target.value
    const isValid = validateEmail(value)
    setFormObj((data) => ({
      ...data,
      userEmail: { value: e.target.value, status: isValid ? 'is-valid' : '' },
    }))
  }

  const formSubmitHandler = (e) => {
    e.preventDefault()
    issueBadge(formObj, setFormObj)
  }

  const clear = (e) => {
    e.preventDefault()
    setFormObj((data) => ({
      state: 'idle',
      userEmail: { status: '', value: '' },
      badgeTitle: '',
      version: '',
      selectedBadge: 'Select the badge',
    }))
  }
  return (
    <div id='IssueBadge'>
      <h4 className='ps-2 ps-md-2 mt-4 title'>Issue a Badge</h4>
      {issueBadgeSuccess && <Info messages={['Badge Issued Successfully']} alertType='alert-success' />}
      <Info messages={[...issueBadgeError]} alertType='alert-danger' />
      <Form
        emailHandler={emailHandler}
        onClearHandler={clear}
        onChangeHandler={onChangeHandler}
        formSubmitHandler={formSubmitHandler}
        badges={badges}
        formObj={formObj}
      />
    </div>
  )
}

const mapStateToProps = ({ badge }) => ({ badge })

export default connect(mapStateToProps, { issueBadge, getBadges })(IssueBadge)
